<template>
  <div class="casedata-layer">
    <div class="table-container">
      <div class="table-title" v-if="step === 0">请标记你认为的异常数据</div>
      <div class="table-title" v-else>请搭建反欺诈智能体</div>
      <div class="table-header">
       <div class="table-header-left">案例数据</div>
       <div class="table-header-right">
            <span><i class="dot1"></i>人工标记异常</span>
            <span><i class="dot2"></i>反欺诈智能体标记异常</span>
            <span><i class="dot3"></i>人工与智能体均异常</span>
       </div>
      </div>
      
      <el-table
        ref="caseTable"
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
        :row-class-name="tableRowClassName">
        
        <el-table-column
          type="selection"
          width="55"
          align="center">
        </el-table-column>
        
        <el-table-column
          prop="a"
          label="交易序号"
          align="center">
        </el-table-column>
        
        <el-table-column
          prop="b"
          label="交易ID"
          align="center">
        </el-table-column>

        <el-table-column
          prop="c"
          label="交易时间"
          align="center">
        </el-table-column>
        
        <el-table-column
          prop="d"
          label="交易地域"
          align="center">
        </el-table-column>
        
        <el-table-column
          prop="e"
          label="商户名称"
          align="center">
        </el-table-column>
        
        <el-table-column
          prop="f"
          label="商户类型"
          align="center">
        </el-table-column>
        
        <el-table-column
          prop="g"
          label="交易金额（元）"
          align="center">
          <template slot-scope="scope">
            ¥{{ scope.row.g.toLocaleString() }}
          </template>
        </el-table-column>
        
        <el-table-column
          prop="h"
          label="支付方式"
          width="120"
          align="center">
        </el-table-column>
        
        <el-table-column
          prop="i"
          label="交易备注"
          min-width="200"
          align="center">
        </el-table-column>
        
        <!-- <el-table-column
          prop="status"
          label="状态"
          width="120"
          align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column> -->
      </el-table>

       <div class="table-footer">
        <template v-if="step === 0">
          <el-button class="reset-btn" type="primary" size="small" @click="resetSelection">重置</el-button>
          <el-button class="submit-btn" type="primary" size="small" @click="markSelectedRows">标记</el-button>
          <span class="selected-count" v-if="selectedRows.length > 0">已选择 {{ selectedRows.length }} 条数据</span>
          <el-button class="prev-btn" @click="handlePrev">
            下一步
          </el-button>
        </template>
        <template v-if="step === 1">
          <!-- <el-button class="prev-btn" @click="handlePrev">
            上一步
          </el-button> -->
          <el-button class="submit-btn" type="primary" size="small" @click="handleBuild">搭建反欺诈分析智能体</el-button>
          <el-button class="submit-btn" type="primary" size="small" @click="handleAnalysis">反欺诈分析</el-button>
        </template>
        <template v-if="step === 2">
          <p class="result-title">分析结果：</p>
          <p class="result-content">人工标记异常数据<span class="s1">{{ rgExceptionCount }}</span>条，反欺诈智能体标记异常数据<span class="s2">{{ aiExceptionCount }}</span>条，相同异常数据<span class="s3">{{ sameExceptionCount }}</span>条，差异数据{{ diffExceptionCount }}条。</p>
        </template>
      </div>
    </div>

     <el-dialog title="请输入API秘钥开始风险分析" class="addDialog" :visible.sync="Visible" width="900px" :show-close="true"
               :close-on-press-escape="false" :close-on-click-modal="false">
      <div class="content-inner">
        <div class="l-inner">
          <div class="item">
            <div class="label-inner">请输入搭建的反欺诈智能体API：</div>
            <el-input v-model="Form.api"></el-input>
          </div>
          <div class="item">
            <p>（工作流API秘钥通过dygpt-工作流-发布渠道获取）</p>
          </div>
        </div>
      </div>
      <div class="footer-inner" slot="footer">
        <el-button type="primary" size="small" @click="handleUse">确 定</el-button>
        <el-button size="small" @click="Visible = false">取 消</el-button>
      </div>
    </el-dialog>

     <div class="dd-inner" v-show="loading">
      <zdyloading style="width: 200px;" ref="zdyloading" :isShowLoading="loading" loadingTxt="智能体分析中，请稍后...">
      </zdyloading>
    </div>
  </div>
</template>

<script>
import zdyloading from '@/components/Zdyloading.vue'
import axios from 'axios'
axios.defaults.timeout = 300000
axios.defaults.withCredentials = false
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
export default {
  name: 'CaseData',
  components: {
    zdyloading
  },
  props: {},
  data () {
    return {
      Visible: false, // 弹窗是否可见
      Form: {
        api: ''
      },
      loading: false, // 加载中
      apiUrl: window.FastGptApiUrl + '/api/v1/chat/completions',
      step: 0, // 当前步骤
      tableData: [{"a":"1","b":"20250520001","c":"2025/5/20 8:30","d":"深圳南山","e":"XX早餐店","f":"餐饮","g":"15","h":"刷卡","i":"常规早餐","status":0},{"a":"2","b":"20250520002","c":"2025/5/20 9:00","d":"深圳南山","e":"XX地铁票务","f":"通勤交通","g":"8","h":"闪付","i":"常规通勤","status":0},{"a":"3","b":"20250520003","c":"2025/5/20 12:00","d":"深圳南山","e":"XX连锁餐厅","f":"餐饮","g":"88","h":"扫码支付","i":"午餐","status":0},{"a":"4","b":"20250520004","c":"2025/5/20 18:30","d":"深圳南山","e":"XX超市","f":"超市零售","g":"320","h":"刷卡","i":"日用品采购","status":0},{"a":"5","b":"20250520005","c":"2025/5/20 21:00","d":"深圳南山","e":"XX线上生鲜店","f":"线上购物","g":"130","h":"APP支付","i":"生鲜采购","status":0},{"a":"6","b":"20250521006","c":"2025/5/21 3:15","d":"北京朝阳","e":"XX奢侈品店","f":"奢侈品零售","g":"58000","h":"刷卡","i":"无备注","status":0},{"a":"7","b":"20250521007","c":"2025/5/21 8:20","d":"深圳南山","e":"XX早餐店","f":"餐饮","g":"12","h":"闪付","i":"常规早餐","status":0},{"a":"8","b":"20250521008","c":"2025/5/21 12:15","d":"深圳南山","e":"XX沙县小吃","f":"餐饮","g":"22","h":"扫码支付","i":"午餐","status":0},{"a":"9","b":"20250521009","c":"2025/5/21 19:00","d":"深圳南山","e":"XX线上商城","f":"线上购物","g":"450","h":"APP支付","i":"服装采购","status":0},{"a":"10","b":"20250522010","c":"2025/5/22 2:40","d":"上海浦东","e":"XX珠宝店","f":"珠宝首饰","g":"32000","h":"刷卡","i":"无备注","status":0},{"a":"11","b":"20250522011","c":"2025/5/22 12:10","d":"深圳南山","e":"XX快餐店","f":"餐饮","g":"25","h":"扫码支付","i":"午餐","status":0},{"a":"12","b":"20250522012","c":"2025/5/22 18:40","d":"深圳南山","e":"XX菜市场","f":"超市零售","g":"85","h":"扫码支付","i":"食材购买","status":0},{"a":"13","b":"20250523013","c":"2025/5/23 10:00","d":"深圳南山","e":"XX超市","f":"超市零售","g":"180","h":"刷卡","i":"零食采购","status":0},{"a":"14","b":"20250523014","c":"2025/5/23 23:50","d":"深圳南山","e":"XX便利店","f":"超市零售","g":"35","h":"闪付","i":"夜间购物","status":0},{"a":"15","b":"20250524015","c":"2025/5/24 4:20","d":"广州天河","e":"XX数码店","f":"数码产品","g":"15000","h":"刷卡","i":"无备注","status":0},{"a":"16","b":"20250524016","c":"2025/5/24 8:40","d":"深圳南山","e":"XX早餐店","f":"餐饮","g":"15","h":"闪付","i":"常规早餐","status":0},{"a":"17","b":"20250524017","c":"2025/5/24 18:30","d":"深圳南山","e":"XX水果店","f":"超市零售","g":"68","h":"扫码支付","i":"水果购买","status":0},{"a":"18","b":"20250525018","c":"2025/5/25 12:30","d":"深圳南山","e":"XX面馆","f":"餐饮","g":"30","h":"扫码支付","i":"午餐","status":0},{"a":"19","b":"20250525019","c":"2025/5/25 19:30","d":"深圳南山","e":"XX电影院","f":"娱乐","g":"98","h":"APP支付","i":"观影消费","status":0},{"a":"20","b":"20250526020","c":"2025/5/26 3:00","d":"香港铜锣湾","e":"XX名表行","f":"奢侈品零售","g":"89000","h":"刷卡","i":"无备注","status":0},{"a":"21","b":"20250526021","c":"2025/5/26 10:00","d":"深圳南山","e":"XX公园票务","f":"娱乐","g":"50","h":"扫码支付","i":"周末游玩","status":0},{"a":"22","b":"20250526022","c":"2025/5/26 12:30","d":"深圳南山","e":"XX海鲜餐厅","f":"餐饮","g":"480","h":"刷卡","i":"周末聚餐","status":0},{"a":"23","b":"20250527023","c":"2025/5/27 14:00","d":"深圳南山","e":"XX书店","f":"零售","g":"120","h":"刷卡","i":"书籍购买","status":0},{"a":"24","b":"20250527024","c":"2025/5/27 2:50","d":"澳门澳门半岛","e":"XX赌场筹码兑换","f":"博彩","g":"50000","h":"刷卡","i":"无备注","status":0},{"a":"25","b":"20250527025","c":"2025/5/27 18:00","d":"深圳南山","e":"XX火锅店","f":"餐饮","g":"280","h":"扫码支付","i":"晚餐聚餐","status":0}],
      selectedRows: [],
      recentlyMarkedRows: [], // 存储最近被标记的行，用于高亮显示
      highRiskNumbers: [], // 存储高危序号，用于背景色标识
      rgExceptionCount: 0, // 人工标记异常数据条数
      aiExceptionCount: 0, // 反欺诈智能体标记异常数据条数
      sameExceptionCount: 0, // 相同异常数据条数
      diffExceptionCount: 0, // 差异数据条数
    }
  },
  computed: {},
  watch: {},
  created () {
    // this.loadMarkedData()
  },
  mounted () {
    this.loadMarkedData()
  },
  methods: {
    // 跳转到fastgpt 里
    handleBuild(){
       this.$router.push({ path: '/case/dygpt', query: { type: sessionStorage.getItem('casetype'), caseno: sessionStorage.getItem('caseno'), routename: 'fanqizha', extend: '' } })
    },

    handleUse () {
      if (!this.Form.api) {
        this.$message.error('请输入API秘钥');
        return;
      }
      //也需要将表单里的数据填充
      sessionStorage.setItem('fqz_key', this.Form.api)
      this.$message.success('API秘钥已应用');
      this.Visible = false;
      this.useFastgptapi()
    },
     handleAnalysis () {
      this.Visible = true
     },
    
    // 反欺诈分析 调用fastgptapi
    useFastgptapi () {
       let fqz_key = sessionStorage.getItem('fqz_key')
        this.loading = true
        let variables = {
            "uid": "asdfadsfasfd2323",
            "name": "张三",
            "input": {"data":"交易序号,交易ID,交易时间,交易地域,商户名称,商户类型,交易金额（元）,支付方式,交易备注;1,20250520001,2025/5/20 8:30,深圳南山,XX早餐店,餐饮,15,刷卡,常规早餐;2,20250520002,2025/5/20 9:00,深圳南山,XX地铁票务,通勤交通,8,闪付,常规通勤;3,20250520003,2025/5/20 12:00,深圳南山,XX连锁餐厅,餐饮,88,扫码支付,午餐;4,20250520004,2025/5/20 18:30,深圳南山,XX超市,超市零售,320,刷卡,日用品采购;5,20250520005,2025/5/20 21:00,深圳南山,XX线上生鲜店,线上购物,130,APP支付,生鲜采购;6,20250521006,2025/5/21 3:15,北京朝阳,XX奢侈品店,奢侈品零售,58000,刷卡,无备注;7,20250521007,2025/5/21 8:20,深圳南山,XX早餐店,餐饮,12,闪付,常规早餐;8,20250521008,2025/5/21 12:15,深圳南山,XX沙县小吃,餐饮,22,扫码支付,午餐;9,20250521009,2025/5/21 19:00,深圳南山,XX线上商城,线上购物,450,APP支付,服装采购;10,20250522010,2025/5/22 2:40,上海浦东,XX珠宝店,珠宝首饰,32000,刷卡,无备注;11,20250522011,2025/5/22 12:10,深圳南山,XX快餐店,餐饮,25,扫码支付,午餐;12,20250522012,2025/5/22 18:40,深圳南山,XX菜市场,超市零售,85,扫码支付,食材购买;13,20250523013,2025/5/23 10:00,深圳南山,XX超市,超市零售,180,刷卡,零食采购;14,20250523014,2025/5/23 23:50,深圳南山,XX便利店,超市零售,35,闪付,夜间购物;15,20250524015,2025/5/24 4:20,广州天河,XX数码店,数码产品,15000,刷卡,无备注;16,20250524016,2025/5/24 8:40,深圳南山,XX早餐店,餐饮,15,闪付,常规早餐;17,20250524017,2025/5/24 18:30,深圳南山,XX水果店,超市零售,68,扫码支付,水果购买;18,20250525018,2025/5/25 12:30,深圳南山,XX面馆,餐饮,30,扫码支付,午餐;19,20250525019,2025/5/25 19:30,深圳南山,XX电影院,娱乐,98,APP支付,观影消费;20,20250526020,2025/5/26 3:00,香港铜锣湾,XX名表行,奢侈品零售,89000,刷卡,无备注;21,20250526021,2025/5/26 10:00,深圳南山,XX公园票务,娱乐,50,扫码支付,周末游玩;22,20250526022,2025/5/26 12:30,深圳南山,XX海鲜餐厅,餐饮,480,刷卡,周末聚餐;23,20250527023,2025/5/27 14:00,深圳南山,XX书店,零售,120,刷卡,书籍购买;24,20250527024,2025/5/27 2:50,澳门澳门半岛,XX赌场筹码兑换,博彩,50000,刷卡,无备注;25,20250527025,2025/5/27 18:00,深圳南山,XX火锅店,餐饮,280,扫码支付,晚餐聚餐"}
        }
        // 生成一个唯一的chatId
        const chatId = new Date().getTime()
        console.log("variables", variables)    
        axios({
          headers: {
            'Authorization': `Bearer ${fqz_key}`
          },
          url: this.apiUrl,
          method: 'POST',
          data: {
            "stream": false,
            "detail": false,
            "chatId": chatId,
            "variables": variables,
            "messages": [
              {
                "content": "开始出题",
                "role": "user"
              }
            ]
          }
        }).then(res => {
          this.loading = false
          if (res?.data && (res.status == 200 || res.status == 304)) {
            let data = res.data
            if (data.code == 514 || data.code == 403) {
              this.$alert('工作流API秘钥不正确，请检查！')
              return
            } else {
              let text = data.choices[0].message.content || ''
              if(text.indexOf('</think>') > -1){
                text = text.split('</think>')[1]
              }
              // 提取最终贷款额度
              // console.log("text>>>>",text);

              // 示例使用
              // const inputStr = `最终返回结果：
              // 序号6；高危（可疑欺诈）。
              // 序号10；高危（可疑欺诈）。
              // 序号15；高危（可疑欺诈）。
              // 序号22；高危（确认违规+欺诈）。`;
              // console.log(this.extractHighRiskNumbers(inputStr)); // 输出："6,10,15,22"
               
              let gptHighRiskNumbers = this.extractHighRiskNumbers(text)
              console.log("gptHighRiskNumbers>>>>",gptHighRiskNumbers);
              
              if (gptHighRiskNumbers) {
               // 如果有高危序号，将其转换为数组
               let highRiskNumbers = gptHighRiskNumbers.split(',');
               console.log("highRiskNumbers>>>>",highRiskNumbers);
               
               // 存储高危序号到组件数据中
               this.highRiskNumbers = highRiskNumbers.map(num => num.trim());
               
               // 遍历高危序号数组，将对应行的status设置为'manual_marked'
               highRiskNumbers.forEach(num => {
                 let row = this.selectedRows.find(r => r.序号 === num.trim());
                 if (row) {
                   row.status = 'manual_marked';
                   // 同时添加到recentlyMarkedRows中用于高亮显示
                   if (!this.recentlyMarkedRows.includes(row)) {
                     this.recentlyMarkedRows.push(row);
                   }
                 }
               });
               
               // 强制刷新表格以应用新的行样式
               this.$nextTick(() => {
                 this.$refs.caseTable.doLayout()
               });
               
               console.log("this.tableData>>>>",this.tableData);
               console.log("recentlyMarkedRows>>>>",this.recentlyMarkedRows);
               
               // 同时被标记
               let tongshiCount = 0
               this.recentlyMarkedRows.forEach(row => {
                 if (highRiskNumbers.includes(row.a)) {
                   tongshiCount++
                 }
               })
               console.log("同时被标记tongshiCount>>>>",tongshiCount);
               
               // 计算人工标记异常数据条数
               this.rgExceptionCount = this.recentlyMarkedRows.length;
               this.aiExceptionCount = highRiskNumbers.length; // 反欺诈智能体标记异常数据条数
               this.sameExceptionCount = tongshiCount; // 相同异常数据条数
               this.diffExceptionCount = this.rgExceptionCount + this.aiExceptionCount - 2*tongshiCount; // 差异数据条数

               this.step = 2

              }else{
                this.$alert('你搭建的智能体有误，请重置后再试！')
              }

            }
          }else{
            this.$alert('你搭建的智能体有误，请重置后再试！')
          }
        }).catch((err) => {
          console.log("Err>>>", err);
          this.$alert('当前网络连接错误，请检查后再试')
          this.loading = false
        })
    },

    extractHighRiskNumbers(str) {
        // 使用正则表达式匹配所有"序号X；高危"模式
        const regex = /序号(\d+)；高危/g;
        const matches = [];
        
        let match;
        while ((match = regex.exec(str)) !== null) {
          matches.push(match[1]); // 提取序号数字
        }
        
        return matches.join(','); // 用逗号拼接
      },

    handleSelectionChange (selection) {
      this.selectedRows = selection
    },
    
    tableRowClassName ({row, rowIndex}) {
      // 检查当前行是否在高危序号列表中
      if (this.highRiskNumbers && this.highRiskNumbers.includes(row.a)) {
        // 如果同时也在recentlyMarkedRows中，返回橙色背景
        if (this.recentlyMarkedRows && this.recentlyMarkedRows.includes(row)) {
          return 'orange-highlight-row'
        }
        // 否则返回红色背景
        return 'red-highlight-row'
      }
      
      // 检查当前行是否在刚刚被标记的选中行中
      if (row.status === 'manual_marked' && this.recentlyMarkedRows && this.recentlyMarkedRows.includes(row)) {
        return 'highlighted-row'
      }
      
      return ''
    },
    
    markSelectedRows () {
      if (this.selectedRows.length === 0) {
        // this.$message.warning('请先选择要标记的数据')
        this.$alert('请先选择要标记的数据')
        return
      }
      
      // 记录当前选中的行，用于后续高亮显示
      this.recentlyMarkedRows = [...this.selectedRows]
      
      this.selectedRows.forEach(row => {
        row.status = 'manual_marked'
      })
      
      this.saveMarkedData()
      this.$message.success(`成功标记 ${this.selectedRows.length} 条数据为人工标记异常`)
      
      // 强制刷新表格以应用新的行样式
      this.$nextTick(() => {
        this.$refs.caseTable.doLayout()
      })
      
      this.$refs.caseTable.clearSelection()
    },

    // 重置
    resetSelection () {
      this.$refs.caseTable.clearSelection()
      this.selectedRows = []
      sessionStorage.removeItem('markedTransactions')
      this.tableData.forEach(item=>{
        this.$set(item,'status', 0)
      })
      setTimeout(() => {
        this.recentlyMarkedRows = []
        this.$refs.caseTable.doLayout()
      }, 300)
      this.$alert('重置成功')
    },

    // 下一步
    handlePrev(){
      let markedTransactions = sessionStorage.getItem('markedTransactions')
      if(!markedTransactions){
        this.$alert('请先标记数据')
        return
      }
      this.step = 1
    },
    
    saveMarkedData () {
      const markedData = this.tableData.filter(item => item.status === 'manual_marked')
      sessionStorage.setItem('markedTransactions', JSON.stringify(markedData))
    },
    
    loadMarkedData () {
      const saved = sessionStorage.getItem('markedTransactions')
      if (saved) {
        const markedData = JSON.parse(saved)
        this.tableData.forEach(item => {
          const marked = markedData.find(marked => marked.a === item.a)
          if (marked) {
            item.status = 'manual_marked'
            // 同时添加到recentlyMarkedRows中用于高亮显示
            if (!this.recentlyMarkedRows.includes(item)) {
              this.recentlyMarkedRows.push(item)
            }
          }
        })
        
        // 恢复选中状态
        this.$nextTick(() => {
          this.recentlyMarkedRows.forEach(row => {
            this.$refs.caseTable.toggleRowSelection(row, true)
          })
        })
      }
    },
    
    getStatusType (status) {
      const statusMap = {
        'normal': 'success',
        'suspicious': 'warning',
        'manual_marked': 'danger',
        'system_marked': 'info'
      }
      return statusMap[status] || 'info'
    },
    
    getStatusText (status) {
      const statusMap = {
        'normal': '正常',
        'suspicious': '可疑',
        'manual_marked': '人工标记异常',
        'system_marked': '系统标记异常'
      }
      return statusMap[status] || '未知'
    }
  }
}
</script>

<style scoped lang="less">
.casedata-layer {
  // padding: 20px;
  // height: calc(100% - 40px);
  height: 100%;
  overflow: auto;
}

.table-container {
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  .table-title{
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 20px;
    text-align: center;
    color:#4568f6;
  }
}

.table-header {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;

  .table-header-left{
    font-size: 18px;
    font-weight: 600;
  }
  
  .table-header-right{
    display: flex;
    align-items: center;
    gap: 20px;
    span{
      display: flex;
    }
    .dot1,.dot2,.dot3{
      display: inline-block;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      margin-right: 5px;
    }
    .dot1{
      background-color: #ffea00;
    }
    .dot2{
      background-color: #ff4949;
    }
    .dot3{
      background-color: #409eff;
    }
  }
}

.table-footer {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  .submit-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: linear-gradient(135deg, #1549F3 0%, #1890ff 100%);
    border: none;
    border-radius: 8px;
    color: #fff;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(21, 73, 243, 0.3);
    }

    &:active {
      transform: translateY(0);
    }
  }

  .reset-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #b8c4e0;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(21, 73, 243, 0.2);
      color: #fff;
    }
  }

  .prev-btn {
    padding: 12px 40px;
    font-size: 16px;
    font-weight: bold;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(21, 73, 243, 0.3);
    border-radius: 8px;
    color: #b8c4e0;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(21, 73, 243, 0.2);
      color: #fff;
    }
  }

  .result-title {
    font-size: 18px;
    font-weight: 600;
    height:24px;
    line-height: 24px;
  }

  .result-content {
    font-size: 18px;
    line-height: 24px;
  }

  .s1{
    color: #ffea00;
    font-weight: bold;
    margin:0 5px;
  }
  .s2{
    color: #ff4949;
    font-weight: bold;
    margin:0 5px;
  }
  .s3{
    color: #409eff;
    font-weight: bold;
    margin:0 5px;
  }
}

.selected-count {
  color: #606266;
  font-size: 14px;
}

/* 自定义表格样式 */
/deep/ .el-table {
  th {
    // background-color: #f5f7fa !important;
    // color: #303133;
    background-color: #303133 !important;
    color: #f5f7fa;
    font-weight: 600;
  }
  
  td {
    padding: 8px 0;
  }
  
  // 高亮行的背景色样式
  .highlighted-row {
    background-color: #ffea00 !important;
    .el-table__cell{
      color:#2e2c2c !important;
    }
    
    &:hover {
      background-color: #ffd700 !important;
    }
    
    td {
      background-color: transparent !important;
    }
  }
  
  // 红色高亮行（高危序号匹配）
  .red-highlight-row {
    background-color: #ff0210 !important;
    .el-table__cell{
      color:#ffffff !important;
    }
    
    &:hover {
      background-color: #e0010e !important;
    }
    
    td {
      background-color: transparent !important;
    }
  }
  
  // 橙色高亮行（高危序号匹配且同时在recentlyMarkedRows中）
  .orange-highlight-row {
    background-color: #f29201 !important;
    .el-table__cell{
      color:#ffffff !important;
    }
    
    &:hover {
      background-color: #e08200 !important;
    }
    
    td {
      background-color: transparent !important;
    }
  }
}

.addDialog {
  backdrop-filter: blur(5px);

  /deep/ .el-dialog {
    border: 1px solid rgba(29, 156, 181, 0.3);
    padding: 0 20px;
    border-radius: 10px;
    background-color: #fff;

    .el-dialog__headerbtn {
      font-size: 20px !important;
    }
  }

  .content-inner {
    height: 500px;

    .label-inner {
      color: #fff;
      margin-bottom: 12px;
      font-size: 15px;
      user-select: none;
    }

    .l-inner {
      // float: left;
      // width: 53%;
      // margin-right: 30px;
      width: 100%;
    }

    .item {
      margin-bottom: 30px;

      /deep/ textarea {
        resize: none;
      }

      .play-icon {
        margin-left: 15px;
        cursor: pointer;
        color: #0f99cb;

        &::before {
          font-size: 20px;
          margin-right: 2px;
          vertical-align: middle;
        }

        &:hover {
          color: #1e589f;
        }
      }
    }

  }

  .footer-inner {
    text-align: center;

    .el-button {
      min-width: 120px;
      letter-spacing: 2px;
    }
  }
}

.dd-inner {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 6, 36, 0.6);

  /deep/ .loading-text {
    color: #fff;
  }
}
</style>
